<template>
<!-- TODO 状态待调整 -->
<div class="top_detail_tip" v-if="dataInfo?.gift_received">
  <span>🎉 你可通过APP订单管理查看奖品/快递信息</span>
  <span class="look" @click="onLookDetail">
    查看详情
    <van-icon name="arrow" />
  </span>

  <!-- 奖项信息详情 -->
  <van-dialog
    v-model:show="dialogCheckForm"
    :show-confirm-button="false"
    :show-cancel-button="false"
    class="top_detail check_form"
  >
    <div class="dialog_check_form rds4">
      <h2 class="fw_bold">奖项信息</h2>
      <div class="award_name">{{ info.address.goods_title }}</div>
      <ul class="form_list">
        <li><span class="font_bold">状态：</span>已领取</li>
        <li><span class="font_bold">{{ $tm('index2024.form.text1')[0] }}：</span>{{ info.address.receiver }}</li>
        <li><span class="font_bold">{{ $tm('index2024.form.text2')[0] }}：</span>{{ info.address.phone }}</li>
        <li><span class="font_bold">{{ $tm('index2024.form.text4')[0] }}：</span>{{ info.addressName }} {{ info.address.address }}</li>
      </ul>
      <div class="submit_btn" @click="dialogCheckForm = false">知道了</div>
    </div>

  </van-dialog>
</div>

<!-- 页面内容 -->
<div class="top_detail">
  <div v-wechat-title="'名厨指数-' + $tm(`index2024.${route.query.leader_type}.title`)" />
  
  <!-- <div id="canvasImg" class="poster_img">
    <img :src="`https://static.mingchu.co/webapp/index2024/detailBg/${route.query.leader_type}.png`" alt=""/>
    <div class="rank ft_bm font_bold">Top <span class="ft_bm">{{ dataInfo?.sort ? addZero(dataInfo.sort) : '--' }}</span></div>
    <div class="headerPic">
      <img :src="dataInfo?.img2 + '?v='+Math.random() || ''" alt="" crossOrigin="anonymous"/>
    </div>
    <div class="nickname">{{ dataInfo?.title || '' }}</div>
  </div> -->

  <canvas v-if="!imageSrc"  class="poster_img" id="canvas" width="654" height="900"></canvas>
  <img v-if="!imageSrc" class="default_img"  :src="`https://static.mingchu.co/webapp/index2024/detailBg/${route.query.leader_type}.png`" alt=""/>
  <img v-else  class="img" @click="addPoint" :src="imageSrc" alt="poster_img" />

  <div v-if="!dataInfo?.gift_received && isShow" class="top_detail_btn" @click="goPath">领取实物奖牌</div>
  <div class="top_detail_btn save" @click="onSave()">{{ utils.is_mini() ? '长按证书保存至相册' : '保存证书至相册' }}</div>
  <div class="page_desc">2024-2025名厨指数</div>
</div>
</template>

<script setup>
import { ref, computed, toRefs, reactive, onMounted, getCurrentInstance } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import i18n from '@/languages'
// import html2canvas from "html2canvas"

import utils, { addZero } from '@/utils/utils'
import { platformType } from '@/utils/index'

// import config from '@/config/config'
import { ajaxHttp } from '@/api/api'
import { Toast } from 'vant'


const instance = getCurrentInstance()
const ctx = instance.ctx
const route = useRoute()
const router = useRouter()
const props = defineProps({
  type: {
    type: String,
    default: ''
  }
})

const dialogCheckForm = ref(false)
const info = reactive({
  address: { // 地址信息
    country_id: '',
    country_name: '',
    province_code: '',
    province_name: '',
    city_code: '',
    city_name: '',
    address: '',
    receiver: '',
    phone: ''
  },
  dataInfo: {},
  addressName: ''
})
const { dataInfo } = toRefs(info)

// 是否展示领奖入口
const isShow = computed(() => {
  if (['ownerPrincipal', 'restaurant'].includes(route.query.leader_type) && info.dataInfo.sort < 31) {
    return true
  }

  return info.dataInfo.sort < 11
})
const onLookDetail = async () => {
  // 获取订单详情数据
  ajaxHttp.$get('/api/ranking2024/order_info', { ...route.query }).then(res => {
    if (res.code === 1) {
      const { gift } = res.data
      info.address = {
        ...res.data.address,
        goods_title: gift.goods_title
      }

      if (!res.data.address.country_name) {
        info.addressName = ''
      } else {
        info.addressName = `${res.data.address.country_name || ''} ${res.data.address.province_name || ''} ${res.data.address.city_name || ''}`
      }
    } else {
      Toast(res.message)
    }
  })

  dialogCheckForm.value = true
}

// 收货地址跳转
const goPath = () => {
  // 埋点
  const type = route.query.leader_type
  sensors.track('MCINDEX2024_getMedal_click', {
    MCINDEX_title: type,
    from: `2024指数_${i18n.global.tm(`index2024.${type}`).title}_领取实物奖牌`,
    PlatformType: platformType()
  })

  const path = `/2024mc/checkForm?leader_type=${type}` 
  router.push(path)
}

// 添加埋点
const addPoint = () => {
  const type = route.query.leader_type
  utils.isGteatChefbrowser() && (sensors.track('MCINDEX2024_save_certificate', {
    MCINDEX_title: type,
    from: `2024指数_${i18n.global.tm(`index2024.${type}`).title}_保存电子证书`,
    PlatformType: platformType()
  }))
}

// 保存至相册
const imageSrc = ref()

function drawRoundedImage(ctx, image, x, y, width, height, radius) {
    ctx.save();
    
    // 创建圆角路径
    ctx.beginPath();
    ctx.moveTo(x + radius, y);
    ctx.lineTo(x + width - radius, y);
    ctx.arcTo(x + width, y, x + width, y + radius, radius);
    ctx.lineTo(x + width, y + height - radius);
    ctx.arcTo(x + width, y + height, x + width - radius, y + height, radius);
    ctx.lineTo(x + radius, y + height);
    ctx.arcTo(x, y + height, x, y + height - radius, radius);
    ctx.lineTo(x, y + radius);
    ctx.arcTo(x, y, x + radius, y, radius);
    ctx.closePath();

    // 绘制边框
    ctx.strokeStyle = '#E5E5E5';
    ctx.lineWidth = 4;
    ctx.stroke();
    
    // 裁剪路径
    ctx.clip();
    
    // 绘制图片
    ctx.drawImage(image, x, y, width, height);
    
    ctx.restore();
}
// 图片生成
const generateImage = () => {
  const canvas = document.getElementById("canvas") // 获取canvas
  const ctx = canvas.getContext("2d") // 对应的CanvasRenderingContext2D对象(画笔)

  const img = new Image() // 创建新的图片对象
  img.setAttribute("crossOrigin",'*')
  img.src = `https://static.mingchu.co/webapp/index2024/detailBg/${route.query.leader_type}.png` + '?v='+Math.random() ?? '';

  img.onload = function () {
    //图片加载完，再draw 和 toDataURL
    ctx.drawImage(img, 0, 0, canvas.width, canvas.height); 

    // 绘制 top
    ctx.font = '50px Arial'; // 设置字体大小和字体类型
    ctx.fillStyle = 'white'; // 设置文字颜色
    const top = `TOP ${info.dataInfo?.sort ? addZero(info.dataInfo.sort) : '--'}`
    const topWidth = ctx.measureText(top).width // 计算文本宽度
    const topX = (canvas.width - topWidth) / 2 // 计算文本的起始位置（水平居中）
    ctx.fillText(top, topX, 245); // 在(x,y)位置绘制文字

    // 绘制名称
    ctx.font = '30px Arial'; // 设置字体大小和字体类型
    const userName = info.dataInfo?.title ?? ''
    const textWidth = ctx.measureText(userName).width;
    const x = (canvas.width - textWidth) / 2;
    ctx.fillText(userName, x, 660);

    // 绘制头像（圆角）
    const avatar = new Image()
    avatar.setAttribute("crossOrigin", '*')

    if (info.dataInfo?.leader_type === 'chef') {
      if (info.dataInfo?.img1.indexOf('?') !== -1) {
        avatar.src = info.dataInfo?.img1 + '&v=' + Math.random()
      } else {
        avatar.src = info.dataInfo?.img1 + '?v=' + Math.random()
      }
    } else {
      if (info.dataInfo?.img2.indexOf('?') !== -1) {
        avatar.src = info.dataInfo?.img2 + '&v=' + Math.random()
      } else {
        avatar.src = info.dataInfo?.img2 + '?v=' + Math.random()
      }
    }

    avatar.onload = function(){

      const imgX = (canvas.width - 268) / 2 // 计算文本的起始位置（水平居中）
      // ctx.drawImage(avatar, imgX, 325, 268, 268);
      drawRoundedImage(ctx, avatar, imgX, 325, 268, 268, 8);

      imageSrc.value = canvas.toDataURL("image/png");
    }
  }
}

// const generateImage = () => {
//   // 保存方式区分环境
//   const element = document.getElementById('canvasImg'); // 需要导出的页面

//   // htmlToImage.toPng(element)
//   // .then(function (dataUrl) {
//   //   // var img = new Image();
    
//   //   console.log('dataUrl====', dataUrl)
//   //   // img.src = dataUrl;
//   //   // document.body.appendChild(img);
//   // })
//   // .catch(function (error) {
//   //   console.error('oops, something went wrong!', error);
//   // });

//   html2canvas(element, {
//     allowTaint: true,
//     useCORS: true,
//     // foreignObjectRendering: true,
//     width: 654,
//     height: 900,
//     // scale: 1,
//   }).then(async (canvas) => {
//     const imageData = canvas.toDataURL()
//     imageSrc.value = imageData

//     console.log('canvas===', canvas)
//     console.log('imageSrc----', imageData)
//   });

// }
const onSave = async (type) => {
  if (utils.isGteatChefbrowser()) {
    // 埋点
    addPoint()
    utils.downloadImg(imageSrc.value)
  }
}

const getUserInfo = async () => {
  const data = { leader_type: route.query.leader_type, leader_id: route.query.leader_id}
  const res = await ajaxHttp.$get('/api/ranking2024/leader_detail', data)

  if (res.code === 1) {
    info.dataInfo = res.data
  }
}
onMounted(async () => {
  // 关闭顶部分享
  utils.hideShare()

  // 获取用户信息
  await getUserInfo()
  generateImage()

  // if (utils.is_mini()) {
  //   setTimeout(() => {
  //     onSave()
  //   }, 1000)
  // }
})
</script>

<style lang="scss" scoped>
.top_detail {
  padding: rem(24);
  position: relative;

  &.check_form {
    .submit_btn {
      background-color: #FAF5E6;
      color: #C99700;
    }
  }
}
.top_detail_tip {
  padding: 0 rem(24);
  height: rem(36);
  line-height: rem(36);
  background-color: rgba(201, 151, 0, 0.1);
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #333;

  .look {
    color: #C99700;
  }
}
.poster_img {
  width: 100%;
  height: rem(450);
  border-radius: rem(8);
  margin-bottom: rem(20);
  color: #fff;
  font-size: rem(14);
  font-weight: 500;
  position: relative;

  .rank {
    font-size: rem(28);
    line-height: rem(36);
    position: absolute;
    top: 20%;
    left: 50%;
    transform: translateX(-50%);
  }

  .headerPic {
    position: absolute;
    top: 31%;
    left: 50%;
    transform: translateX(-50%);
    width: rem(134);
    height: rem(134);
    border-radius: rem(8);
    background: #fff;
    overflow: hidden;

    img {
      width: 100%;
      height: 100%;
    }
  }

  .nickname {
    position: absolute;
    top: 65%;
    left: 50%;
    transform: translateX(-50%);
  }
}
.img,
.default_img {
  width: rem(327);
  height: rem(450);
  margin-bottom: rem(20);
}
.default_img {
  position: absolute;
  left: rem(24);
}
.top_detail_btn {
  width: 100%;
  height: rem(48);
  line-height: rem(48);
  text-align: center;
  font-size: rem(16);
  background-color: #C99700;
  color: #fff;
  border-radius: rem(2);
}
.save {
  margin-top: rem(10);
  background-color: #FAF5E6;
  color: #C99700;
}
.page_desc {
  font-size: rem(14);
  color: #ccc;
  text-align: center;
  margin-top: rem(40);
  font-weight: 300;
}
.award_name {
  font-size: rem(16);
  font-weight: 500;
}
</style>
